/* eslint-disable */
import React, { useState } from 'react'
import { Modal, Tabs } from 'antd'
import { sagaModal } from 'redux-saga-modal'
import OrderForm from './OrderForm'
import ImportForm from './ImportForm'

const isTenantMode = process.env.APP_MODE === 'tenant';

const CreateOrderDialog = ({
  modal,
  isOpen,
  show,
  update,
  destroy,
  click,
  submit,
  hide,
  showModal,
  updateModal,
  submitModal,
  clickModal,
  hideModal,
  destroyModal,
  ...ownProps
}) => {
  const [activeKey, setActiveKey] = useState('1')
  return (
    <Modal
      title={ownProps.title || '创建工单'}
      destroyOnClose
      footer={null}
      width={900}
      centered
      keyboard={false}
      maskClosable={false}
      visible={isOpen}
      onCancel={hide}>
      {isTenantMode && <Tabs defaultActiveKey={activeKey} tabBarStyle={{ border: 0, marginBottom: 0 }} onChange={(val) => { setActiveKey(val) }}>
        <Tabs.TabPane tab="手动创建" key="1"></Tabs.TabPane>
        <Tabs.TabPane tab="导入表格创建" key="2"></Tabs.TabPane>
      </Tabs>}
      <div style={{ minHeight: 592 }}>
        {activeKey == 1 && <OrderForm {...ownProps} submit={submit} />}
        {activeKey == 2 && <ImportForm {...ownProps} submit={submit} />}
      </div>
    </Modal>
  )
}

export default sagaModal({
  name: 'CREATE_ORDER_DIALOG',
})(CreateOrderDialog)
